module.exports = __webpack_public_path__ + "img/vk-icon.f1e9eb8.svg";